import { useGetCountryListNew } from 'all-in-one-shared-api';
import { Select, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils';
import { useKeycloakReady } from 'hooks';
import { useEffect, useState } from 'react';

const { Option } = Select;

interface MobileNumberPrefix {
  defaultValue?: string;
  defaultAreacode?: string;
  border?: boolean;
  handleChange: (value: string) => void;
  handleSetCountry?: React.Dispatch<React.SetStateAction<string>>;
  areacodeFlag?: string;
  defaultCountry?: string;
  handleCountryOri?: React.Dispatch<React.SetStateAction<string>>;
  inputType?: string;
}

const MobileNumberPrefix = ({
  defaultValue,
  defaultAreacode,
  handleChange,
  border = false,
  handleSetCountry,
  areacodeFlag,
  defaultCountry,
  handleCountryOri,
}: MobileNumberPrefix) => {
  const { t, i18n } = useTranslation();
  const [countryCode, setCountryCode] = useState(defaultValue ?? '');
  const [areaCode, setAreaCode] = useState(defaultAreacode ?? '');
  const [showInput, setShowInput] = useState(areacodeFlag == 'Y' || defaultAreacode ? true : false);
  const [countryListData, setCountryListData] = useState<
    {
      countryAlpha3: string;
      searchLabel: string;
      label: string;
      labelTc: string;
      sanctionLevel: string;
      isd: string;
      code: string;
      areaCode: string[];
      riskLevel: string;
      isSanction: string;
      country: string;
      areaCodeFlag: string;
    }[]
  >([]);
  const { keycloak } = useKeycloakReady();

  const { shouldFetch, data } = useGetCountryListNew('useGetCountryListNew', keycloak.token ?? '');
  const selectChange = (
    value: string,
    option:
      | { searchLabel: string; label: string; desc: string; descTc: string; areaCode: string[]; areaCodeFlag: string }
      | {
          searchLabel: string;
          label: string;
          desc: string;
          descTc: string;
          areaCode: string[];
          areaCodeFlag: string;
        }[],
  ) => {
    // 下拉框
    // 首先检查 option 是否是数组
    console.log(option);
    if (Array.isArray(option)) {
      setCountryCode(option[0].label);
      if (handleSetCountry) handleSetCountry(option[0].desc);
      // 如果是数组，取第一个元素（假设你只关心第一个选中的选项）
      if (option.length > 0 && option[0].areaCodeFlag == 'Y') setShowInput(true);
      else setShowInput(false);
      if (option.length > 0 && option[0].areaCode && option[0].areaCode.length === 1) {
        setAreaCode(option[0].areaCode[0]);
        handleChange(`${option[0].label} ${option[0].areaCode[0]}`);
      } else {
        setAreaCode('');
        handleChange(`${option[0].label}`);
      }
    } else if (option) {
      setCountryCode(option.label);
      if (handleSetCountry) handleSetCountry(option.desc);
      if (option.areaCodeFlag == 'Y') setShowInput(true);
      else setShowInput(false);
      if (option.areaCode && option.areaCode.length === 1) {
        // 如果不是数组，直接检查单个对象
        setAreaCode(option.areaCode[0]);
        handleChange(`${option.label} ${option.areaCode[0]}`);
      } else {
        setAreaCode('');
        handleChange(`${option.label}`);
      }
    }
  };
  useEffect(() => {
    shouldFetch(true);
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (!data) return;
    shouldFetch(false);
    setCountryListData(data);
    if (handleSetCountry)
      handleSetCountry(
        data?.find(
          (item) =>
            item.code == (defaultValue ? defaultValue : '+852') && item.countryAlpha3 == (defaultCountry ?? 'HKG'),
        )?.label ?? '',
      );
    if (handleCountryOri)
      handleCountryOri(
        data?.find(
          (item) =>
            item.code == (defaultValue ? defaultValue : '+852') && item.countryAlpha3 == (defaultCountry ?? 'HKG'),
        )?.label ?? '',
      );

    //eslint-disable-next-line
  }, [data]);
  return (
    <>
      <Select
        // defaultValue={defaultValue ?? defaultPrefix}
        dropdownMatchSelectWidth={false}
        optionLabelProp="label"
        onChange={selectChange}
        value={countryCode}
        showSearch
        size="large"
        filterOption={(input, option) => {
          const label = option?.searchLabel ?? '';
          return label.toLowerCase().includes(input.toLowerCase());
        }}
      >
        {countryListData.map(({ label, searchLabel, labelTc, code, areaCode, areaCodeFlag }) => (
          // Note(Andy Chow): the 'value' of some items in countryCodes is the same => use label as key instead
          <Option
            key={searchLabel}
            value={`${code} ${label}`}
            label={code}
            searchLabel={searchLabel}
            areaCode={areaCode}
            desc={label}
            descTc={labelTc}
            areaCodeFlag={areaCodeFlag}
          >
            {isLocaleEnglish(i18n.language) ? label : labelTc}
          </Option>
        ))}
      </Select>
      {showInput && (
        <Input
          value={areaCode}
          placeholder={t('life.contact.areacode')}
          // bordered={border}
          bordered={false}
          size="large"
          className="areacode"
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '');
            setAreaCode(value);
            if (value !== '') handleChange(`${countryCode} ${value}`);
            else handleChange(`${countryCode}`);
          }}
          style={{
            marginRight: '16px',
            borderBottom: border ? '1px solid #d9d9d9' : '1px solid #cccccc',
            background: '#fff',
            fontSize: '20px',
            fontFamily: 'Rotobo500',
            padding: '0 11px',
          }}
        />
      )}
    </>
  );
};

export default MobileNumberPrefix;
